<template>
  <div>
    <div class="chartFilter" style="">
      <div>
        <!-- Period Filters -->
        <select v-model="periodType" class="year_select">
          <option value="" selected="selected">Period Type</option>
          <option value="Annual">Annual</option>
          <option value="Daily">Daily</option>
        </select>
        <date-picker
          v-show="periodType == 'Daily'"
          class="pl-2"
          @change="getDate"
          value-type="YYYY-MM-DD"
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
        ></date-picker>
        <date-picker
          v-show="periodType == 'Annual'"
          class="pl-2"
          @change="getDate"
          value-type="YYYY"
          v-model="value1"
          type="year"
          year
          placeholder="Select Year"
        ></date-picker>
        <!--  -->
        <!-- <date-picker class="pl-2" @change=getDate value-type='YYYY-MM-DD' v-model="value1" type="date" range placeholder="Select date range"></date-picker> -->
        <select class="country_select toUpper" v-model="genderSelect">
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <button class="btn btn_apply float-right mr-2" @click="triggerFilter()">
        {{ $t("Filter.apply") }}
      </button>
    </div>
    <div class="content-grid">
      <div class="row align-items-stretch no-gutters">
        <div class="col-lg-12">
          <div class="card linelist_table">
            <div class="card-header" style="justify-content: space-between;">
              <div>{{ $t("Sidebar.linelist") }}</div>
              <div class="d-flex">
                <button
                  @click="getAllCasesData()"
                  class="btn pull-right btn-sm mr-2"
                  style="background-color: #238cbb !important;color:#fff"
                >
                  Download All Data
                </button>
                <export-excel :data="userListDataArrary" :fields="excelFields">
                  <button
                    class="btn pull-right btn-sm"
                    style="background-color: #238cbb !important;color:#fff"
                  >
                    Excel Download
                  </button>
                </export-excel>
              </div>
            </div>
            <div class="card-body">
              <v-client-table
                ref="lineListTable"
                id="alert_table"
                :columns="columns"
                :data="userListDataArrary"
                :options="options"
              >
                <span slot="Contact Cases" slot-scope="row">
                  <i
                    class="fa fa-plus-circle "
                    style="font-size: 18px;"
                    @click="getCases(row)"
                  >
                  </i>
                </span>
                <span slot="Case History" slot-scope="row">
                  <i
                    class="fa fa-plus-circle "
                    style="font-size: 18px;"
                    @click="getCaseHistory(row, 'index')"
                  >
                  </i>
                </span>
                <div slot="child_row">
                  <div id="contactCasesTable">
                    <h5 v-show="contactFlag">Contact Cases</h5>
                    <v-client-table
                      v-show="contactFlag"
                      ref="casesTable"
                      :columns="casesColumn"
                      :data="casesData"
                      :options="options"
                    >
                      <span slot="Case History" slot-scope="row">
                        <i
                          class="fa fa-plus-circle "
                          style="font-size: 18px;"
                          @click="getCaseHistory(row)"
                        >
                        </i>
                      </span>
                    </v-client-table>
                  </div>
                  <span v-show="!contactFlag">No records</span>
                </div>
              </v-client-table>

              <b-modal size="md" id="modal-alert" centered hide-footer>
                <template v-slot:modal-title> Alert </template>
                <div class="modal-body">
                  {{ message }}
                </div>
              </b-modal>

              <b-modal size="xl" scrollable id="modal-case-history" hide-footer>
                <template v-slot:modal-title>
                  Case History ({{ childRow["First Name"] }})</template
                >
                <div class="modal-body">
                  <b-row class="">
                    <b-col>
                      <b-card>
                        <b-card-body class="m-0 p-0">
                          <b-card-title>
                            <b-img
                              center
                              style="max-width: 10rem;"
                              src="https://saveph.duredemos.com/dashboard-v2/user.svg"
                              alt="User Icon"
                            ></b-img>
                            <!-- <img style="max-width: 10rem;" src=""> -->
                          </b-card-title>
                          <!-- <b-card-sub-title class="mb-2">Card Sub Title</b-card-sub-title> -->
                          <b-card-text>
                            <b-row>
                              <b-col><b>Name</b></b-col>
                              <b-col>{{ childRow["First Name"] }}</b-col>
                            </b-row>
                            <b-row>
                              <b-col><b>Gender</b></b-col>
                              <b-col>{{ childRow["Sex"] }}</b-col>
                            </b-row>
                            <b-row>
                              <b-col><b>Age</b></b-col>
                              <b-col>{{ childRow["Age"] }}</b-col>
                            </b-row>
                          </b-card-text>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col cols="8">
                      <div role="tablist">
                        <b-card no-body class="mb-1" v-for="(event, index) in caseHistoryDataArray" :key="index">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block href="#" v-b-toggle="`coll_${index}`" variant="info">{{
                                  programs[0].programStages.filter(
                                    (stage) => stage.id === event.programStage
                                  )[0].displayName
                                }}</b-button>
                            </b-card-header>
                            <b-collapse :id="`coll_${index}`" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <!-- <b-tabs content-class="mt-3" justified> -->
                                        <p  v-for="(dataelem, id) in event.dataValues" :key="id">
                                            <b-row>
                                                <b-col>{{
                                 programs[0].programStages.filter(
                                    (stage) => stage.id === event.programStage
                                  )[0].programStageDataElements.filter((entity) =>entity.dataElement.id === dataelem.dataElement)[0].dataElement.displayName.split("_")[1]
                                }}</b-col>
                                <!-- if(stage.id === event.programStage){
                                        return stage.programStageDataElements.filter((entity) =>entity.dataElement.id === dataelem.dataElement)
                                      }
                                    } -->
                                                <!-- <b-col>{{dataElements.filter((entity) =>entity.id === dataelem.dataElement)[0].displayName.split("_")[1]}}</b-col> -->
                                                <b-col>{{ dataelem.value }}</b-col>
                                            </b-row>
                                        </p>
                                    <!-- </b-tabs> -->
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JQuery from "jquery";
let $ = JQuery;
import ApiServices from "../service/ApiServices";
import { _ } from "vue-underscore";
import swal from "sweetalert2";
export default {
  components: {},
  data() {
    return {
      styleObject: {
        "background-color": "#f50000",
        color: "#fff",
      },
      periodType: "",
      indexUIC: "",
      contactUIC: "",
      indexName: "",
      indexGender: "",
      indexAge: "",
      indexPhoneNo: "",
      userData: JSON.parse(sessionStorage.getItem("userData")),
      excelFields: {
        UIC: "UIC",
        "Client Type": "Client Type",
        "Given Name": "Given Name",
        "Family Name": "Family Name",
        Age: "Age",
        Gender: "Gender",
        "Age in years": "Age",
        "Registered by": "byUser",
        // 'Type of TB':'index_Type of TB',
      },
      columns: [
        // 'UIC',
        "Client Type",
        "Given Name",
        "Age",
        "Gender",
        "Phone Number (Primary)",
        "registered by",
        "Case History",
        "Contact Cases",
      ],
      casesColumn: [
        // 'UIC',
        "Client Type",
        "First Name",
        "Age",
        "Sex",
        "Phone Number (Primary)",
        "Registered By",
        "Case History",
      ],
      casesData: [],
      casesOption: {
        skin: "table",
        showChildRowToggler: false,
        uniqueKey: "UIC",
        texts: {
          filterPlaceholder: "Search",
        },
      },
      userListDataArrary: [],
      masterDataArray: [],
      options: {
        showChildRowToggler: false,
        uniqueKey: "Instance",
        headings: {
          "Given Name": "Name",
          index_Address: "Address",
          index_Age: "Age",
          index_Gender: "Gender",
          "index_Type of TB": "Type of TB",
          byUser: "Registered by",
          "By User": "Registered by",
          "Phone Number (Primary)": "Phone Number",
        },
        rowClassCallback(row) {
          // console.log(row)
          return row.Instance;
        },
        cellClasses: {
          "Contact Cases": [
            {
              class: "text-center",
              condition: (row) => true,
            },
          ],
          "Case History": [
            {
              class: "text-center",
              condition: (row) => true,
            },
          ],
        },
        skin: "table",
        texts: {
          filterPlaceholder: "Search",
        },
        sortIcon: {
          down: "fas fa-long-arrow-alt-up",
          up: "fas fa-long-arrow-alt-down",
        },
      },
      contactFlag: false,
      message: "",
      caseHistoryPanel: {},
      caseHistoryData: {},
      childRow: [],
      value1: {},
      fromDate: "",
      toDate: "",
      genderSelect: "",
      program: [],
      dataElements: [],
      caseHistoryDataArray: [],
    };
  },
  methods: {
    getAllCasesData() {
      var instance = {
        // "programid": "1370779",
        // "orgid": "61"
        programid: this.userData.programid,
        orgid: this.userData.orgid,
      };
      swal.fire({
        icon: "success",
        text: "File will be downloaded shortly.",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
      ApiServices.RestPostCall(
        "ltbi/generic/common/linelist/getlinelistdata",
        instance
      ).then((res) => {
        console.log(res);
        let a = document.createElement("a");
        a.href = res.filepath;
        a.target = "_blank";
        a.click();
      });
    },
    triggerFilter() {
      this.getLineListData();
    },
    genderFilter() {},
    getDate() {
      if (!this.value1[0] && !this.value1[0]) {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        this.toDate =
          d.getFullYear() +
          "-" +
          (("" + month).length < 2 ? "0" : "") +
          month +
          "-" +
          (("" + day).length < 2 ? "0" : "") +
          day;
        this.fromDate = "2000-01-01";
      } else if (this.periodType == "Daily") {
        this.fromDate = this.value1[0];
        this.toDate = this.value1[1];
      } else {
        this.fromDate = this.value1 + "-01-01";
        this.toDate = this.value1 + "-12-31";
      }
    },
    getCaseHistory(row, type) {
      console.log(row);
      this.childRow = row.row;
      this.$root.isLoading = true;
      var instance = {
        sysuic: row.row.sysUIC,
      };
      let trackedEntityUrl =
        "metadata?programs:filter=id:eq:"+this.userData.programid+"&programs:fields=:owner,displayName,userAccesses,programTrackedEntityAttributes[:owner,trackedEntityAttribute[id,name,formName,description,valueType,optionSet,domainType]],programStages[:owner,user[id,name],displayName,attributeValues[:all,attribute[id,name,displayName]],programStageDataElements[:owner,renderType,formName,dataElement[id,displayName,formName,description,compulsory,valueType,optionSet,domainType]],notificationTemplates[:owner,displayName],dataEntryForm[:owner],programStageSections[:owner,displayName,dataElements[id,displayName]]]";
      ApiServices.RestGetCall(trackedEntityUrl).then((r) => {
        this.$root.isLoading = false;
        this.programs = r.programs
         console.log(r,this.programs);
        let mainModalContent = "";
        ApiServices.RestGetCall(
          "trackedEntityInstances/" +
            row.row.Instance +
            ".json?program="+this.userData.programid+"&fields=*?"
        )
          .then((res) => {
            console.log("Events >>>>", res);
            this.caseHistoryDataArray = res.enrollments[0].events;
            this.$bvModal.show("modal-case-history");
          })
          .catch((error) => {
            // this.$root.isLoading = false
            console.log(error);
            // swal("Request Failed.");
          });
      });
    },
    getLineListData() {
      this.$root.isLoading = true;
      var instance = {
        programid: this.userData.programid,
        orgid: this.userData.orgid,
        fromdate: this.fromDate,
        todate: this.toDate,
        clienttype: "",
      };
      ApiServices.RestGetCall(
        "trackedEntityInstances/query.json?ou="+this.userData.organisationUnits[0].id+"&ouMode=ACCESSIBLE&program="+this.userData.programid+"&paging=false&skipPaging=true"
      ).then((r) => {
        this.$root.isLoading = false;
        console.log(r);
        const allowed = ["created", "inactive"];

        let tempDataColID = [];
        let tempData = [];
        let tempColumns = [];

        let instanceIndex = r.headers.findIndex(
          (header) => header.name === "instance"
        );
        tempDataColID.push(instanceIndex.toString());

        let UICID = r.headers.findIndex(
          (header) => header.column === "UIC" && "Order number"
        );

        let nameIndex = r.headers.findIndex(
          (header) => header.column.trim().toLowerCase() === "name"
        );

        for (let i in r.headers) {
          if (true) {
            tempColumns.push({
              Header: r.headers[i].column,
              accessor: i,
              //accessor: r.headers[i].column,
            });
            tempDataColID.push(i);
          }
        }
        //console.log(tempDataColID);
        //console.log(tempColumns);
        tempColumns.sort((a, b) => {
          // console.log(a);
          // console.log(b);
          if (typeof a.Header === "string" && typeof b.Header === "string") {
            let fa = a.Header.toLowerCase(),
              fb = b.Header.toLowerCase();

            if (fa.length < fb.length) {
              return -1;
            }
            if (fa.length > fb.length) {
              return 1;
            }
            return 0;
          }
        });

        for (let i in r.rows) {
          let tempObj = {};
          for (let j in r.rows[i]) {
            tempObj[
              r.headers[j].column.includes("_")
                ? r.headers[j].column.split("_")[1]
                : r.headers[j].column
            ] = r.rows[i][j];
          }
          tempData.push(tempObj);
        }
        this.userListDataArrary = tempData;
        console.log(tempColumns, tempData);
      }).catch((error) => {
          this.$root.isLoading = false;
          console.log(error);
        });
    },
    getCases(row) {
      this.$root.isLoading = true;
      if (this.indexUIC == "") {
        var UIC = "";
        UIC = row.row.Instance;
        $("." + UIC).addClass("highlight");
        this.$refs.lineListTable.toggleChildRow(UIC);
        this.indexUIC = UIC;
      } else if (this.indexUIC == row.row.sysUIC) {
        $("." + this.indexUIC).removeClass("highlight");
        this.$refs.lineListTable.toggleChildRow(this.indexUIC);
        this.indexUIC = "";
        this.$root.isLoading = false;
        return;
      } else {
        $("." + this.indexUIC).removeClass("highlight");
        this.$refs.lineListTable.toggleChildRow(this.indexUIC);
        var UIC = "";
        UIC = row.row.Instance;
        this.indexUIC = UIC;
        $("." + UIC).addClass("highlight");
        this.$refs.lineListTable.toggleChildRow(UIC);
      }
      this.indexName = row.row.index_Name;
      this.indexGender = row.row.index_Gender;
      this.indexAge = row.row.index_Age;
      this.indexPhoneNo = row.row["Phone Number"];
      this.casesData = [];
      ApiServices.RestGetCall(
        `trackedEntityInstances/${UIC}.json?program=`+this.userData.programid+`&fields=relationships`
      )
        .then((res) => {
          console.log(res)
          if (res.relationships.length > 0) {
            this.getChildrenById(res.relationships)
            this.$root.isLoading = false;
          } else {
            this.contactFlag = false;
            this.$root.isLoading = false;
            // this.$bvModal.show('modal-alert');
          }
        })
        .catch((error) => {
          // this.$root.isLoading = false
          console.log(error);
          // swal("Request Failed.");
        });
    },
     getChildrenById(relationshipsArr){
      let p = [];
      relationshipsArr.map((relobj) => {
        let url = `trackedEntityInstances/${relobj.to.trackedEntityInstance.trackedEntityInstance}.json?program=U1nNSk2geJh&fields=*?`;
        p.push(ApiServices.RestGetCall(url));
        return true;
      });

      Promise.all([...p]).then(([...res]) => {
        let childrenArr = [...res];
        // console.log("Children -->>", childrenArr);
        let subRowData = [];

        childrenArr.map((children) => {
          let tempObj = {};

        //   console.log("Child Row -------->", children.attributes);

          let caseName = children.attributes.find(
            (el) => el.displayName.trim().toLowerCase() === "name"
          );

          children.attributes.map((attr, index) => {
            //console.log(index + ") " + attr.displayName + " : " + attr.value);
            tempObj[attr.displayName.includes("_") ? attr.displayName.split("_")[1] : attr.displayName] = attr.value;
            return true;
          });
          tempObj['Instance'] = children.trackedEntityInstance
          subRowData.push(tempObj);
          return true;
        });
        console.log("Sub Row Data >>>", subRowData);
        this.casesData = subRowData;
        this.contactFlag = true;
      });
  }
  },
  mounted() {
    // this.showPanel()
    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    this.toDate =
      d.getFullYear() +
      "-" +
      (("" + month).length < 2 ? "0" : "") +
      month +
      "-" +
      (("" + day).length < 2 ? "0" : "") +
      day;
    this.fromDate = "2000-01-01";
    this.getLineListData();
  },
};
</script>
